export default {
  name: 'FolderMixin',
  data() {
    return {
      DocumentTypes: {
        LINK: 1,
        FORM: 2,
        PARTDRAWING: 3,
      }
    };
  },

  mounted() { },

  methods: {
    folderName(folder) {
      if (folder.InheritedFromType == 'MachineJobHistory') {
        return this.$t('servicesystem.common_objects.document.files_for_specific_orders');
      }
      else if (folder.InheritedFromType == 'Job') {
        return this.$t('servicesystem.common_objects.job.job') + ' ' + folder.InheritedFromName;
      }
      else {
        return folder.InheritedFromName;
      }
    },

    folderDescription(folder) {
      if (folder.InheritedFromType == 'Supplier') {
        return this.$t('servicesystem.common_objects.document.supplier_documents');
      }
      else if (folder.InheritedFromType == 'MachineModel') {
        return this.$t('servicesystem.common_objects.document.product_documents');
      }
      else if (folder.InheritedFromType == 'Machine') {
        return this.$t('servicesystem.common_objects.document.machine_documents');
      }
      else if (folder.InheritedFromType == 'MachineJobHistory') {
        return this.$t('servicesystem.common_objects.document.job_documents')
      }
      else {
        return null;
      }
    },

    folderColor(folder) {
      if (folder.InheritedFromType == 'MachineJobHistory') {
        return '#d271e9';
      }
      else if (folder.InheritedFromType == 'Machine') {
        return '#4E9EEE';
      }
      else {
        return '#7185E9';
      }
    },

    countNestedFiles(folder) {
      var count = folder?.Files?.length ?? 0;
      var folderArr = Object.assign([], folder?.Folders);
      while (folderArr.length) {
        var current = folderArr.shift();
        var copy = Object.assign([], current.Folders)
        folderArr.push(...copy);
        count += current.Files ? current.Files.length : 0;
      }
      return count;
    },

    countNestedFilesNotThisFolder(folder) {
      var count = 0;
      var folderArr = Object.assign([], folder.Folders);
      while (folderArr.length) {
        var current = folderArr.shift();
        var copy = Object.assign([], current.Folders)
        folderArr.push(...copy);
        count += current.Files ? current.Files.length : 0;
      }
      return count;
    },

    unNestFiles(folder) {
      var fileArr = Object.assign([], folder.Files);
      var folderArr = Object.assign([], folder.Folders);
      while (folderArr.length) {
        var current = folderArr.shift();
        var folderArrCopy = Object.assign([], current.Folders)
        folderArr.push(...folderArrCopy);
        var fileArrCopy = Object.assign([], current.Files);
        fileArr.push(...fileArrCopy);
      }
      return fileArr;
    },

    filterFileArrByType(fileArr, typeId) {
      if (!fileArr || !fileArr.length) {
        return []
      }
      else if (!typeId) {
        return fileArr;
      } else if (typeId == 'Media') {
        return fileArr.filter(x => x.IsMedia);
      }
      else if (typeId == this.DocumentTypes.LINK) {
        return fileArr.filter(x => (x.TypeId <= this.DocumentTypes.LINK) && !x.IsMedia);
      }
      else {
        return fileArr.filter(x => (x.TypeId == typeId) && !x.IsMedia);
      }
    },

    filterFileArrBySearch(fileArr, keyword) {
      if (!keyword) {
        return fileArr;
      }
      else {
        return fileArr.filter(x => JSON.stringify(x).toLocaleLowerCase().includes(keyword.toLocaleLowerCase()));
      }
    },

    countFilesByType(typeId, folder) {
      var allFiles = this.unNestFiles(folder);
      return Object.assign([], this.filterFileArrByType(allFiles, typeId)).length;
    },

    filterFiles(searchword, typeId, folder) {
      folder.Files = this.filterFileArrByType(folder.Files, typeId);
      folder.Files = this.filterFileArrBySearch(folder.Files, searchword);
      folder.Folders.forEach(subfolder => {
        this.filterFiles(searchword, typeId, subfolder)
      });
      return folder;
    },

    chipOptions(folder) {
      var options = [
        { value: null, text: this.$t('servicesystem.common_objects.commonterms.all') + ' (' + this.countFilesByType(null, folder) + ')' },
      ];
      var mediaCount = this.countFilesByType('Media', folder);
      var manualsCount = this.countFilesByType(this.DocumentTypes.LINK, folder);
      var formsCount = this.countFilesByType(this.DocumentTypes.FORM, folder);
      var partDrawingCount = this.countFilesByType(this.DocumentTypes.PARTDRAWING, folder);
      if (mediaCount) {
        options.push({ value: 'Media', text: this.$t('servicesystem.common_objects.document.media') + ' (' + mediaCount + ')' },)
      }
      if (manualsCount) {
        options.push({ value: this.DocumentTypes.LINK, text: this.$t('servicesystem.common_objects.document.documents') + ' (' + manualsCount + ')' },)
      }
      if (formsCount) {
        options.push({ value: this.DocumentTypes.FORM, text: this.$t('servicesystem.common_objects.document.forms') + ' (' + formsCount + ')' },)
      }
      if (partDrawingCount) {
        options.push({ value: this.DocumentTypes.PARTDRAWING, text: this.$t('servicesystem.common_objects.document.part_drawings') + ' (' + partDrawingCount + ')' },)
      }
      return options;
    },
  },

  computed: {},

  watch: {},
}